import { createSlice } from '@reduxjs/toolkit';

import type { AppState } from './model';

const initialState: AppState = {
  loading: false,
  countLoading: 0,
};

const appSlice = createSlice({
  name: '@app',
  initialState,
  reducers: {
    showLoading: state => {
      state.countLoading++;
    },
    hideLoading: state => {
      state.countLoading--;
    },
  },
});

export const { showLoading, hideLoading } = appSlice.actions;
export default appSlice.reducer;
